import { Card, Col, Flex, Image, Row, Switch } from "antd";
import Bank from "../../../../../assets/images/bank.svg";

type Props = {
  data: any;
};

export default function BankCard({ data }: Props) {
  if (!data?.bankAccount) return null;
  const { bankAccount, is_default } = data || {};

  const {
    account_name,
    account_number,
    bank_name,
    branch_name,
    routing_number,
    swift_code,
    bank_logo,
  } = bankAccount || {};
  return (
    <Card className="shadow-sm rounded-xl !w-full border-none bg-theme-slate-25">
      <Row gutter={[16, 16]}>
        {/* Logo */}
        <Col span={24} style={{ textAlign: "left" }}>
          <Flex justify="space-between" align="start">
            <Image
              src={bank_logo || Bank}
              alt="City Bank"
              height={80}
              preview={false}
            />
          </Flex>
        </Col>

        {/* Left column */}
        <Col span={12}>
          <p className="text-theme-gray-500 font-medium text-sm">Bank Name</p>
          <p className="text-theme-gray-900 font-medium text-sm mb-1.5">
            {bank_name}
          </p>

          <p className="text-theme-gray-500 font-medium text-sm">
            Account Name
          </p>
          <p className="text-theme-gray-900 font-medium text-sm mb-1.5">
            {account_name}
          </p>

          <p className="text-theme-gray-500 font-medium text-sm">
            Routing Number
          </p>
          <p className="text-theme-gray-900 font-medium text-sm">
            {routing_number}
          </p>
        </Col>

        {/* Right column */}
        <Col span={12}>
          <p className="text-theme-gray-500 font-medium text-sm">Branch Name</p>
          <p className="text-theme-gray-900 font-medium text-sm mb-1.5">
            {branch_name}
          </p>

          <p className="text-theme-gray-500 font-medium text-sm">
            Account Number
          </p>
          <p className="text-theme-gray-900 font-medium text-sm mb-1.5">
            {account_number}
          </p>

          <p className="text-theme-gray-500 font-medium text-sm">SWIFT Code</p>
          <p className="text-theme-gray-900 font-medium text-sm">
            {swift_code || "N/A"}
          </p>
        </Col>
      </Row>
      {/* Switch at bottom */}
      <Flex align="center" gap={8} className="mt-4">
        <Switch disabled checked={is_default} />
        <span className="text-theme-gray-24 font-medium">Set as Default</span>
      </Flex>
    </Card>
  );
}
